import "../config/globalConstants.js";
import "../config/breakpoints.js";
import { useMatchMedia as e } from "./useMatchMedia.js";
import { ScaleContext as t } from "../components/Scale/ScaleContext.js";
import { useContext as n } from "react";
//#region src/hooks/useScaleFactor.ts
var r = (r, i) => {
	let a = i === void 0 ? 1 : i, { scaleFactor: o } = n(t), s = r ?? o;
	return e("(min-width: 2540px)") ? s : a;
};
//#endregion
export { r as useScaleFactor };
